import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abf4e3dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "auth"
}
const _hoisted_2 = {
  key: 1,
  class: "auth"
}
const _hoisted_3 = { class: "auth-info" }
const _hoisted_4 = {
  key: 2,
  class: "auth"
}

import { useApi } from '@/hooks/useApi';
import { useBaseAsync, useRoute, useRouter } from 'juou-managebase-ui';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authInfo = ref({} as any);

const result = ref<boolean>();
const addWx = useBaseAsync(async(authCode: string) => {
  try {
    const res = await useApi().wxApi.addWxwx({
      authCode,
    });
    if (!res.data.data) {
      throw new Error();
    }
    authInfo.value = res.data.data || {};
    result.value = true;
  } catch (error) {
    result.value = false;
  }
});

const addWeapp = useBaseAsync(async(authCode: string) => {
  try {
    const res = await useApi().weappApi.addWeappweapp({
      authCode,
    });
    if (!res.data.data) {
      throw new Error();
    }
    authInfo.value = res.data.data || {};
    result.value = true;
  } catch (error) {
    result.value = false;
  }
});

if (route.query?.auth_code && route.query?.type) {
  const { auth_code: authCode, type } = route.query as any;
  if (type === '1') {
    addWx(authCode);
  } else {
    addWeapp(authCode);
  }
} else {
  result.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_el_result = _resolveComponent("el-result")!

  return ((typeof result.value) !== 'boolean')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_result, {
          icon: "info",
          title: "授权",
          "sub-title": "正在查询授权结果..."
        })
      ]))
    : (result.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_result, {
            icon: "success",
            title: "授权成功"
          }, {
            extra: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, " 名称：" + _toDisplayString(authInfo.value.name), 1),
                _createElementVNode("div", null, " AppId：" + _toDisplayString(authInfo.value.appid), 1),
                _createElementVNode("div", null, " 主体名称：" + _toDisplayString(authInfo.value.principalName), 1)
              ])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_result, {
            icon: "error",
            title: "授权失败",
            "sub-title": "请重新扫码授权或联系技术人员"
          })
        ]))
}
}

})